import { styled } from 'stitches.config'
import { Stack } from 'components/Stack'

export const SentInstructionsRoot = styled(Stack, {
  backgroundColor: '$tertiary-200',
  padding: '$14 $3',
  minHeight: '100vh',

  '@bp1': {
    padding: '$10 $3',
  },

  '@bp2': {
    padding: '$10 144px',
  },

  '@bp3': {
    padding: '$10 144px',
    maxWidth: 'calc($max/2)',
  },
})

export const Description = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  flex: 1,
  gap: '$4',

  '@bp2': {
    justifyContent: 'flex-end',
    gap: '$5',
  },
})

export const ResendButtonWrapper = styled('div', {
  width: '100%',
  maxWidth: 'calc($max/2 - $$py * 2)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  gap: '$4',
  flex: 1,

  '@bp2': {
    justifyContent: 'space-between',
  },
})
